var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-6 article-type-eyebrow"},[_c('i',{class:_vm.iconClass}),_vm._t("default",[_vm._v("Heading")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }